<template>
  <div class="guide">
    <van-nav-bar title="康塔科技隐私保护指引" left-arrow @click-left="back" />
    <div class="guide_wrap">
      <p>康塔科技消费充值服务协议</p>
      <p>更新日期： 2020年11月30日</p>
      <p>生效日期：2020年11月30日</p>
      <p>欢迎您使用康塔科技消费充值服务！</p>
      <p>《康塔科技消费充值服务协议》（以下简称“本协议”）由您与康塔科技共同缔结，本协议具有合同效力。为使用康塔科技消费充值服务，您应当阅读并遵守本协议及《康塔科技隐私保护指引》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者减轻我们责任的条款、管辖与法律适用条款，以及开通或使用某项服务的单独协议。限制、免责条款可能以黑体加粗形式提示您注意。</p>
      <p>除非您已阅读并接受本协议所有条款，否则您无权使用康塔科技提供的服务。您使用康塔科技的服务即视为您已阅读并同意上述协议的约束。</p>
      <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。　　</p>
      <p>一、【协议的范围】</p>
      <p>1.1本协议是您与康塔科技之间关于用户使用康塔科技消费充值服务所订立的协议。“康塔科技”是指康塔科技公司及其相关服务可能存在的运营关联单位。“用户”是指使用康塔科技相关服务的使用人，在本协议中更多地称为“您”。</p>
      <p>1.2本协议项下的服务是指康塔科技消费充值服务，具体是指康塔科技通过互联网（含移动互联网）向用户提供的技术服务平台，用户通过使用康塔科技提供的技术服务平台向第三方或其代理人为自己或他人进行指定产品或业务的充值（以下简称“本服务”）。您已知悉，本协议项下的服务仅是康塔科技为您提供充值业务的技术服务平台，康塔科技不是向您提供充值服务的服务商或代理商，也不是您的代理商、合伙人、雇员或雇主等经营关系人。康塔科技提供充值的主体均为第三方，而非康塔科技（除非康塔科技另有特别、明确说明由康塔科技提供的充值除外)。您和提供充值服务的主体进行充值合作，康塔科技不参与您与第三方的具体充值合作。您使用前述服务过程中所涉及的支付服务由财付通支付科技有限公司（以下简称“财付通”）提供，您应同时遵守财付通的相关规定，具体以您与财付通的约定为准。本服务可能会包括多个品牌，具体以康塔科技在各个平台上向用户提供的具体服务内容为准。</p>
      <p>1.3 本协议内容同时包括《康塔科技隐私保护指引》，上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何业务规则、单独协议的接受，即视为您对本协议全部的接受。</p>
      <p>二、【帐号与密码安全】</p>
      <p>2.1您在使用康塔科技的服务时可能需要注册一个帐号，该账号可以为平台登录账号。关于您使用该帐号的具体规则，请遵守《康塔科技隐私保护指引》等单独协议。</p>
      <p>2.2您使用不同的账号所享受的本服务内容可能会存在不同，您对此表示完全理解并同意。</p>
      <p>2.3康塔科技特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。</p>
      <p>三、【用户个人信息保护】</p>
      <p>3.1保护用户个人信息是康塔科技的一项基本原则。</p>
      <p>3.2您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。例如，您为了使用消费充值服务，需要您填写您的电话号码。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
      <p>3.3一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
      <p>3.4康塔科技将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
      <p>3.5康塔科技不会将您的个人信息转移或披露给任何非关联的第三方，除非：</p>
      <p>（1）相关法律法规或法院、政府机关要求；</p>
      <p>（2）为完成合并、分立、收购或资产转让而转移；　　</p>
      <p>（3）为了履行本协议的目的；</p>
      <p>（4）为提供您要求的服务所必需；</p>
      <p>（5）您授权同意披露的；</p>
      <p>（6）您主动分享给第三方的；或</p>
      <p>（7）法律法规另有规定的。</p>
      <p>3.6康塔科技非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用康塔科技的服务前，应事先取得您家长或法定监护人（以下简称"监护人"）的书面同意。</p>
      <p>四、【使用本服务的方式及范围】</p>
      <p>4.1除非您与康塔科技另有约定，您同意本服务仅为您个人非商业性质的使用。</p>
      <p>4.2您使用本服务可能需要下载客户端软件，也可能需要通过登录康塔科技所运营的网站或平台以及其他康塔科技授权的平台、渠道。对于使用客户端软件的，康塔科技给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件及服务。</p>
      <p>4.3您应当通过康塔科技提供或认可的方式使用本服务。您依本协议条款所取得的权利不可转让。</p>
      <p>4.4您不得使用未经康塔科技授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。</p>
      <p>4.5 本服务许可的范围</p>
      <p>4.5.1 康塔科技给予您一项个人的、不可转让及非排他性的许可，以使用本服务。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。</p>
      <p>4.5.2 您可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。</p>
      <p>4.5.3 本条及本协议其他条款未明示授权的其他一切权利仍由康塔科技保留，您在行使这些权利时须另外取得康塔科技的书面许可。康塔科技如果未行使前述任何权利，并不构成对该权利的放弃。</p>
      <p>五、【用户注意事项】</p>
      <p>5.1 您理解并同意：本服务的某些功能可能会让第三方知晓您的信息，例如：您通过使用本服务由第三方为您提交的手机号码进行充值，第三方可以知悉用户提交的手机号码等信息。</p>
      <p>5.2 您在使用本服务时，可能会另有单独的协议、相关业务规则等（以下统称为“单独协议”），您在使用该项服务前请阅读并同意相关的单独协议。</p>
      <p>5.3 您理解并同意康塔科技将会尽其商业上的合理努力保障您在本软件及服务中的数据存储安全，但是，康塔科技并不能就此提供完全保证，包括但不限于以下情形：</p>
      <p>5.4 康塔科技不对您在本软件及服务中相关数据的删除或储存失败负责；</p>
      <p>5. 4.1 康塔科技有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本软件及服务中的相关数据；</p>
      <p>5.4.2 如果您停止使用本软件及服务或服务被终止或取消，康塔科技可以从服务器上永久地删除您的数据。服务停止、终止或取消后，康塔科技没有义务向您返还任何数据。</p>
      <p>5.4.3 用户在使用本软件及服务时，须自行承担如下来自康塔科技不可掌控的风险内容，包括但不限于：</p>
      <p>5.4.3.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；</p>
      <p>5.4.3.2 如果需下载软件，用户必须选择与所安装手机相匹配的软件版本，否则，由于软件与手机型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
      <p>5.4.3.3 用户在使用本服务访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
      <p>5.4.3.4 用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
      <p>5.4.3.5 由于无线网络信号不稳定、无线网络带宽小等原因，所引起的用户登录失败、资料同步不完整、页面打开速度慢等风险。</p>
      <p>5.4.3.6 用户对其所充值的产品或业务享有合法权益，保证不会侵犯任何第三方的合法权益，保证不会违反国家相关法律法规的规定。例如，您是您所充值的手机号码的合法使用人或取得了其合法使用人的授权。</p>
      <p>5.5 第三方产品和服务</p>
      <p>5.5.1 您在使用本服务第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。康塔科技和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
      <p>5.5.2 因用户使用本服务或要求康塔科技提供特定服务时，本服务会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，康塔科技不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与康塔科技无关，康塔科技不承担任何责任。</p>
      <p>六、【按现状提供服务】</p>
      <p>您理解并同意，康塔科技的服务是按照现有技术和条件所能达到的现状提供的。康塔科技会尽最大努力向您提供服务，确保服务的连贯性和安全性；但康塔科技不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</p>
      <p>七、【自备设备】</p>
      <p>7.1您应当理解，您使用康塔科技的服务需自行准备与相关服务有关的终端设备（如电脑、调制解调器等装置）及带宽等资源，并承担所需的费用（如电话费、上网费等费用），您需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
      <p>7.2您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。</p>
      <p>八、【广告】</p>
      <p>8.1您同意康塔科技可以在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。</p>
      <p>8.2康塔科技可能为您提供选择关闭广告信息的功能，但任何时候您都不得以本协议未明确约定或康塔科技未书面许可的方式屏蔽、过滤广告信息。</p>
      <p>8.3康塔科技依照法律的规定对广告商履行相关义务，您应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，您因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，康塔科技不承担责任。</p>
      <p>8.4您同意，对康塔科技服务中出现的广告信息，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对依该广告信息进行的交易负责。</p>
      <p>九、【收费服务】</p>
      <p>9.1康塔科技的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。</p>
      <p>9.2康塔科技可能根据实际需要对收费服务的收费标准、方式进行修改和变更，康塔科技也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，康塔科技将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。</p>
      <p>十、【第三方提供的产品或服务】</p>
      <p>10.1 您在康塔科技平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。</p>
      <p>10.2 如前所述，康塔科技仅为您提供消费充值业务的技术服务平台，康塔科技不是向您提供消费充值服务的服务商或代理商，也不是您的代理商、合伙人、雇员或雇主等经营关系人。康塔科技充值平台上提供充值的主体均为第三方，而非康塔科技（除非康塔科技另有特别、明确说明由康塔科技提供的充值除外)。您和提供充值服务的第三方主体进行充值合作，康塔科技不参与您与第三方的具体充值合作。第三方应向您就您在康塔科技充值平台上所享受的充值服务提供发票，您理解并明白，康塔科技并不是向您提供发票的主体，您不会向康塔科技索要发票。但康塔科技会尽量协助您向第三方索取发票。</p>
      <p>10.3 第三方提供的产品或服务策略及具体内容由该第三方决定，康塔科技并不参与其中。例如，某些第三方是按地区提供产品或服务，不同的地区会有不同的产品或服务策略，我们并不能保证您一定可以享受到第三方提供的产品或服务；如果您无法享受第三方提供的产品或服务，具体情况请咨询该第三方，康塔科技对此不承担任何责任。</p>
      <p>10.4 您已知悉并同意，对于您通过使用本服务所接受的第三方服务，由第三方向您提供相应的客服服务。康塔科技仅在合理的范围内对您提供必要支持和协助。如因用户使用第三方服务引发的任何争议或纠纷，应由该第三方负责解决，康塔科技不承担任何责任。康塔科技不对第三方服务提供客服支持，若您需要获取支持，请与第三方联系。</p>
      <p>十一、【基于软件提供服务】</p>
      <p>若康塔科技依托“软件”向您提供服务，您还应遵守以下约定：</p>
      <p>11.1您在使用本服务的过程中可能需要下载软件，对于这些软件，康塔科技给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用本服务的目的而使用这些软件。</p>
      <p>11.2为了改善用户体验、保证服务的安全性及产品功能的一致性，康塔科技可能会对软件进行更新。您应该将相关软件更新到最新版本，否则康塔科技并不保证其能正常使用。</p>
      <p>11.3康塔科技可能为不同的终端设备开发不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。您可以直接从康塔科技的网站上获取软件，也可以从得到康塔科技授权的第三方获取。如果您从未经康塔科技授权的第三方获取软件或与软件名称相同的安装程序，康塔科技无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。</p>
      <p>11.4除非康塔科技书面许可，您不得从事下列任一行为：</p>
      <p>（1）删除软件及其副本上关于著作权的信息；</p>
      <p>（2）对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；</p>
      <p>（3）对康塔科技拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
      <p>（4）对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经康塔科技授权的第三方工具/服务接入软件和相关系统；</p>
      <p>（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
      <p>（6）通过非康塔科技开发、授权的第三方软件、插件、外挂、系统，登录或使用康塔科技软件及服务，或制作、发布、传播非康塔科技开发、授权的第三方软件、插件、外挂、系统。</p>
      <p>十二、【知识产权声明】</p>
      <p>12.1康塔科技在本服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归康塔科技所有，用户在使用本服务中所产生的内容的知识产权归用户或相关权利人所有。</p>
      <p>12.2除另有特别声明外，康塔科技提供本服务时所依托软件的著作权、专利权及其他知识产权均归康塔科技所有。</p>
      <p>12.3康塔科技在本服务中所使用的“QuantaData”、“康塔科技”、“康塔”及LOGO形象等商业标识，其著作权或商标权归康塔科技所有。</p>
      <p>12.4上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经康塔科技、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</p>
      <p>十三、【用户违法行为】</p>
      <p>13.1您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：</p>
      <p>（1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</p>
      <p>（2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</p>
      <p>（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；</p>
      <p>（4）发布、传送、传播广告信息及垃圾信息；</p>
      <p>（5）其他法律法规禁止的行为。</p>
      <p>13.2如果您违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求康塔科技给予协助。造成损害的，您应依法予以赔偿，康塔科技不承担任何责任。</p>
      <p>13.3如果康塔科技发现或收到他人举报您发布的信息违反本条约定，康塔科技有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，康塔科技有权视用户的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止QQ号码或微信号码使用，追究法律责任等措施。</p>
      <p>13.4您违反本条约定，导致任何第三方损害的，您应当独立承担责任；康塔科技因此遭受损失的，您也应当一并赔偿。</p>
      <p>十四、【遵守当地法律监管】</p>
      <p>14.1您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。</p>
      <p>14.2您应避免因使用本服务而使康塔科技卷入政治和公共事件，否则康塔科技有权暂停或终止对您的服务。</p>
      <p>十五、【用户发送、传播的内容与第三方投诉处理】</p>
      <p>15.1您通过本服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。</p>
      <p>15.2您发送或传播的内容应有合法来源，相关内容为您所有或您已获得权利人的授权。</p>
      <p>15.3您同意康塔科技可为履行本协议或提供本服务的目的而使用您发送或传播的内容。</p>
      <p>15.4如果康塔科技收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，您同意康塔科技有权进行独立判断并采取删除、屏蔽或断开链接等措施。</p>
      <p>十六、【不可抗力及其他免责事由】</p>
      <p>16.1您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断、延迟或受阻。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，康塔科技将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失康塔科技在法律允许的范围内免责。</p>
      <p>16.2康塔科技作为技术服务平台仅按现状提供服务，在法律允许的范围内，康塔科技对以下情形导致的服务中断、延迟受阻不承担责任：</p>
      <p>（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
      <p>（2）用户、第三方或康塔科技的电脑软件、系统、硬件、网络和通信线路出现故障；</p>
      <p>（3）用户操作不当，包括但不限于用户提交错误的充值号码或账号错误；</p>
      <p>（4）用户通过非康塔科技授权的方式使用本服务；</p>
      <p>（5）其他康塔科技无法控制或合理预见的情形。</p>
      <p>16.3您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，康塔科技不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：</p>
      <p>（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
      <p>（2）因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>
      <p>（3）其他因网络信息或用户行为引起的风险。</p>
      <p>16.4您理解并同意，本服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，康塔科技不承担法律责任。</p>
      <p>16.5康塔科技依据本协议约定获得处理违法违规内容的权利，该权利不构成康塔科技的义务或承诺，康塔科技不能保证及时发现违法行为或进行相应处理。</p>
      <p>16.6在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意康塔科技有关防范诈骗犯罪的提示。</p>
      <p>十七、【隐私权保护】</p>
      <p>康塔科技重视对用户隐私的保护，关于您的用户资料和其他特定资料依《康塔科技隐私保护指引》受到保护与规范，详情请参阅《康塔科技隐私保护指引》。</p>
      <p>十八、【协议的生效与变更】</p>
      <p>18.1您使用康塔科技的服务即视为您已阅读本协议并接受本协议的约束。</p>
      <p>18.2康塔科技有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。</p>
      <p>18.3本协议条款变更后，如果您继续使用康塔科技提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用康塔科技提供的软件或服务。</p>
      <p>十九、【服务的变更、中断、终止】</p>
      <p>19.1康塔科技可能会对服务内容进行变更，也可能会中断、中止或终止服务。</p>
      <p>19.2您理解并同意，康塔科技有权自主决定经营策略。在康塔科技发生合并、分立、收购、资产转让时，康塔科技可向第三方转让本服务下相关资产；康塔科技也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以康塔科技通知的为准。</p>
      <p>19.3如发生下列任何一种情形，康塔科技有权不经通知而中断或终止向您提供的服务：</p>
      <p>（1）根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</p>
      <p>（2）您违反相关法律法规或本协议的约定；</p>
      <p>（3）按照法律规定或主管部门的要求；</p>
      <p>（4）出于安全的原因或其他必要的情形。</p>
      <p>19.4康塔科技有权按本协议9.2条的约定进行收费。若您未按时足额付费，康塔科技有权中断、中止或终止提供服务。</p>
      <p>19.5您有责任自行备份存储在本服务中的数据。如果您的服务被终止，康塔科技可以从服务器上永久地删除您的数据,但法律法规另有规定的除外。服务终止后，康塔科技没有义务向您返还数据。</p>
      <p>二十、【管辖与法律适用】</p>
      <p>20.1本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
      <p>20.2本协议签订地为中华人民共和国广东省深圳市南山区。 </p>
      <p>20.3若您和康塔科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地（即中国广东省深圳市南山区）有管辖权的人民法院管辖。</p>
      <p>20.4本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
      <p>20.5本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
      <p>二十一、【未成年人使用条款】</p>
      <p>21.1若用户未满18周岁，则为未成年人，应在监护人监护、指导下阅读本协议和使用本服务。</p>
      <p>21.2未成年人用户涉世未深，容易被网络虚象迷惑，且好奇心强，遇事缺乏随机应变的处理能力，很容易被别有用心的人利用而又缺乏自我保护能力。因此，未成年人用户在使用本服务时应注意以下事项，提高安全意识，加强自我保护：</p>
      <p>（1）认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活；</p>
      <p>（2）填写个人资料时，加强个人保护意识，以免不良分子对个人生活造成骚扰；</p>
      <p>（3）在监护人或老师的指导下，学习正确使用网络；</p>
      <p>（4）避免陌生网友随意会面或参与联谊活动，以免不法分子有机可乘，危及自身安全。</p>
      <p>21.3监护人、学校均应对未成年人使用本服务时多做引导。特别是家长应关心子女的成长，注意与子女的沟通，指导子女上网应该注意的安全问题，防患于未然。</p>
      <p>二十二、【其他】</p>
      <p>22.1你使用本服务即视为你已阅读并同意受本协议的约束。康塔科技有权在必要时修改本协议条款。你可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果你继续使用本服务，即视为你已接受修改后的协议。如果你不接受修改后的协议，应当停止使用本服务。</p>
      <p>22.2康塔科技基于提供本服务所发布的各项公告、规则等作为本协议的有效组成部分，与本协议具有同等法律效力。具体公告、规则等内容以康塔科技发布的为准。</p>
      <p>22.3如果您对本协议或本服务有意见或建议，请通过http://www.quantadata.cn与我们联系；您也可以将您的问题发送至kt@quantadata.cn，我们会给予您必要的帮助。（正文完）</p>
      <div style="display: flex; justify-content: flex-end"><span>广州康塔科技有限公司</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Guide',
  created() {

  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};

</script>

<style lang="less" scoped>
.guide {
  .guide_wrap {
    width: 87%;
    background: #fff;
    margin: 0.12rem auto;
    padding: 0.12rem 0.15rem;
    p {
      font-size: 0.12rem;
      color: #333;
      line-height: 0.2rem;
      span {
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
